import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'app/auth.service';

@Component({
  selector: 'app-verify-bank-transfer',
  templateUrl: './verify-bank-transfer.component.html',
  styleUrls: ['./verify-bank-transfer.component.css']
})
export class VerifyBankTransferComponent implements OnInit {

  payments = []

  adPlans = []

  options = [
    {value: 'all', viewValue: 'All'},
    {value: 'true', viewValue: 'Verified'},
    {value: 'false', viewValue: 'Not Verified'}
  ]

  selectedOption = 'all'

  availablePayments = []

  constructor( private route: ActivatedRoute, private adminService: DataService, private notification: MatSnackBar, private auth: AuthService) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { adPlans: any }) =>{
      this.adPlans = data.adPlans
    })
    this.adminService.getTransactions().subscribe(data => {
      let payments = data.transactions
      if(payments.length > 0){
        for(let payment of payments){
          if(payment.paymentMethod != 'esewa' && payment.paymentMethod != 'Pay In Cash'){
            this.adminService.getProperty(payment.property_id).subscribe(data => {
              let adPlan = this.adPlans.find(adPlan => adPlan.id == data.propertyAd.ad_plan_id)
              if(adPlan){
                payment['plan'] = adPlan.plan
                payment['amount'] = adPlan.price
              }
              payment['previewLink'] = environment.url + '/property-preview/'+data.propertyAd.id+'?token='+this.auth.accessToken
              this.payments.push(payment)
            })
          }
        }
        this.availablePayments = this.payments
      }
    })
  }

  verifyPayment(payment){
    payment.status = ! payment.status
    this.adminService.verifyTransaction(payment.id, payment.status).subscribe(data => {
      if(data.status){
        this.openNotification('Action has been completed!')
        if(payment.status){
          this.selectedOption = 'true'
        }else{
          this.selectedOption = 'false'
        }
      }
    }, error => {
      payment.status = ! payment.status
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  filterPayments(){
    if(this.selectedOption == 'all'){
      this.availablePayments = this.payments
    }else if(this.selectedOption == 'true'){
      this.availablePayments = []
      for(let payment of this.payments){
        if(payment.status){
          this.availablePayments.push(payment)
        }
      }
    }else{
      this.availablePayments = []
      for(let payment of this.payments){
        if(payment.status == false){
          this.availablePayments.push(payment)
        }
      }
    }
  }

  openNotification(message){
    this.notification.open(message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
